// @flow

import React, { Component, type ComponentType } from 'react';
import { connect } from 'react-redux';

import { postTutorPassword } from 'actions/tutor';

import PasswordForm from 'containers/password-form';
import Layout from 'components/shared/layout';
import Wrapper from 'components/shared/wrapper';

type PassedInPropsType = {
  isForClaimAccount?: boolean,
};

type PropsFromStateType = {
  resetPasswordForm: any,
  flash: any,
  query: string,
  isLoading: number,
};

const mapStateToProps = ({
  form: { password: resetPasswordForm },
  router,
  application: { flash, isLoading },
}): PropsFromStateType => ({
  resetPasswordForm,
  flash,
  query: router.location.search,
  isLoading,
});

type DispatchPropsType = {
  dispatchPostTutorPassword: typeof postTutorPassword,
};

const mapDispatchToProps: DispatchPropsType = {
  dispatchPostTutorPassword: postTutorPassword,
};

type PropsType = PropsFromStateType & DispatchPropsType & PassedInPropsType;

class ResetPassword extends Component<PropsType, void> {
  getResetToken = () => {
    const { isForClaimAccount, query } = this.props;

    const tokenParamLength = isForClaimAccount
      ? 'claim_token='.length
      : 'reset_password_token='.length;

    const resetPasswordToken = query.slice(tokenParamLength + 1);

    return resetPasswordToken;
  };

  handleClick = () => {
    const {
      resetPasswordForm: { values },
      dispatchPostTutorPassword,
    } = this.props;
    const resetPasswordToken = this.getResetToken();

    dispatchPostTutorPassword({
      data: {
        attributes: {
          password: values.password,
          resetPasswordToken,
        },
      },
    });
  };

  render() {
    const { isForClaimAccount, flash, isLoading } = this.props;

    return (
      <Wrapper hasFlash={!!flash}>
        <Layout>
          <PasswordForm
            resetPassword
            isForClaimAccount={isForClaimAccount}
            handleClick={this.handleClick}
            controlledLoading={isLoading}
          />
        </Layout>
      </Wrapper>
    );
  }
}

const Connected: ComponentType<PassedInPropsType> = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPassword);

export default Connected;



// WEBPACK FOOTER //
// ./src/screens/reset-password/index.js